import axios from 'axios';

import $ from 'jquery'

import PageContext from "../Context/PageContext";
import { useContext, useState } from "react";

import uniqid from 'uniqid';
import { createAddElementAction } from "../history/element.history";

export default function ImageSection(props: any) {

    const setWhichSubSectionOpen = props.setWhichSubSectionOpen;
    const whichSubSectionOpen = props.whichSubSectionOpen;

    const [isLoader, setIsLoader] = useState(false);

    const { addItem, imgUserList, addImgUserList, history,removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, setObjItems, objItems

     } = useContext(PageContext);

    function onFileUpload() {
        $('#upload-file-image').click();
    }

    async function fileActionUpload(event: any) {

        // Create an object of formData
        const formData = new FormData();
        var file = event.target.files[0];
        if (!file) return;

        formData.append("image", file, file.name);

        //active loader
        setIsLoader(true);

        try {
            const response = await axios.post(
                process.env.REACT_APP_URL_BACK + "/upload-image",
                formData
            );

            if (response.status === 200) {

                setIsLoader(false);

                const imageUrl =
                    process.env.REACT_APP_URL_BACK +
                    "/uploads/images/" +
                    response.data.image;

                //ON ATTEND les dimensions
                const size = await getImageSize(imageUrl);

                if (addImgUserList != null) {
                    addImgUserList({ "imageUrl": imageUrl, "size": size });
                }

                console.log("addImgUserList");
            }
        } catch (error) {
            setIsLoader(false);
            console.error(error);
        }
    }

    function getImageSize(url: any) {
        return new Promise((resolve, reject) => {
            const img = new Image();

            img.onload = () => {
                resolve({
                    width: img.naturalWidth,
                    height: img.naturalHeight
                });
            };

            img.onerror = reject;
            img.src = url;
        });
    }

    function addImg(imgItem: any) {
        /* Should be clone for working with different obj */

        //dans les json de données, on a besoin d'avoir width et height pour les opérations comme crop et mise en cadre
        //alors on a stocker les valeurs de taille, pour calculer les valeurs de height, comme on set width à 300
        var cHeight = 300 * imgItem.size.height / imgItem.size.width;

        let copyJson = {
            "id": "ll15wqyw",
            "type": "image-element",
            "class": "image-element",
            "style": {

            },
            "x": 568.9999694824219,
            "y": 230,
            "text": "upload",
            "isLock": false,
            "width": 300,
            "height": cHeight,
            "src": ""
        }
        copyJson.id = uniqid();
        copyJson.src = imgItem.imageUrl;

        if (addItem != null) {
            addItem(copyJson);

            //on sort la mécanique history hors de addItem pour éviter l'effet cyclique
            const action = createAddElementAction(copyJson, { removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, addItem, setObjItems, objItems });
            history.add(action);
        }
    }

    const listImgUser = imgUserList.map((imgItem: any) =>
        <div className='img-section-elem' onClick={() => addImg(imgItem)}>
            <img src={imgItem.imageUrl} />
        </div>
    );

    return (
        <div>
            <div className="btn-list-section" style={{display:'flex'}}>
                <label htmlFor="upload">
                    <button className="main-button2" onClick={onFileUpload} >
                        <div className='svg-icone-button'><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.105 5.97188C10.197 6.10979 10.34 6.20551 10.5026 6.23797C10.6652 6.27044 10.834 6.237 10.9719 6.145C11.1098 6.053 11.2055 5.90999 11.238 5.74742C11.2704 5.58485 11.237 5.41604 11.145 5.27812L10.105 5.97188ZM15.625 5C15.4592 5 15.3003 5.06585 15.1831 5.18306C15.0658 5.30027 15 5.45924 15 5.625C15 5.79076 15.0658 5.94973 15.1831 6.06694C15.3003 6.18415 15.4592 6.25 15.625 6.25V5ZM13.125 11.25L12.6831 11.6919C12.8003 11.809 12.9593 11.8749 13.125 11.8749C13.2907 11.8749 13.4497 11.809 13.5669 11.6919L13.125 11.25ZM13.75 3.75C13.75 3.58424 13.6842 3.42527 13.5669 3.30806C13.4497 3.19085 13.2908 3.125 13.125 3.125C12.9592 3.125 12.8003 3.19085 12.6831 3.30806C12.5658 3.42527 12.5 3.58424 12.5 3.75H13.75ZM15.7544 9.50437C15.8682 9.3865 15.9312 9.22862 15.9298 9.06475C15.9284 8.90088 15.8626 8.74412 15.7468 8.62824C15.6309 8.51236 15.4741 8.44663 15.3103 8.4452C15.1464 8.44378 14.9885 8.50678 14.8706 8.62063L15.7544 9.50437ZM11.3794 8.62063C11.2615 8.50678 11.1036 8.44378 10.9397 8.4452C10.7759 8.44663 10.6191 8.51236 10.5032 8.62824C10.3874 8.74412 10.3216 8.90088 10.3202 9.06475C10.3188 9.22862 10.3818 9.3865 10.4956 9.50437L11.3794 8.62063ZM18.125 15V6.875H16.875V15H18.125ZM10.625 5.625L11.145 5.27812L11.1438 5.27625L11.1375 5.2675C11.1162 5.23557 11.0939 5.20431 11.0706 5.17375C10.8066 4.82224 10.5055 4.50017 10.1725 4.21313C9.57062 3.69688 8.64875 3.125 7.5 3.125V4.375C8.22625 4.375 8.86688 4.74063 9.35875 5.1625C9.62016 5.38783 9.85691 5.64029 10.065 5.91563L10.1056 5.9725C10.1056 5.97187 10.105 5.97187 10.625 5.625ZM7.5 3.125H3.75V4.375H7.5V3.125ZM1.875 5V15H3.125V5H1.875ZM3.75 16.875H16.25V15.625H3.75V16.875ZM16.25 5H15.625V6.25H16.25V5ZM3.75 3.125C3.25272 3.125 2.77581 3.32254 2.42417 3.67417C2.07254 4.02581 1.875 4.50272 1.875 5H3.125C3.125 4.83424 3.19085 4.67527 3.30806 4.55806C3.42527 4.44085 3.58424 4.375 3.75 4.375V3.125ZM18.125 6.875C18.125 6.37772 17.9275 5.90081 17.5758 5.54917C17.2242 5.19754 16.7473 5 16.25 5V6.25C16.4158 6.25 16.5747 6.31585 16.6919 6.43306C16.8092 6.55027 16.875 6.70924 16.875 6.875H18.125ZM1.875 15C1.875 15.4973 2.07254 15.9742 2.42417 16.3258C2.77581 16.6775 3.25272 16.875 3.75 16.875V15.625C3.58424 15.625 3.42527 15.5592 3.30806 15.4419C3.19085 15.3247 3.125 15.1658 3.125 15H1.875ZM16.875 15C16.875 15.1658 16.8092 15.3247 16.6919 15.4419C16.5747 15.5592 16.4158 15.625 16.25 15.625V16.875C16.7473 16.875 17.2242 16.6775 17.5758 16.3258C17.9275 15.9742 18.125 15.4973 18.125 15H16.875ZM13.75 11.25V3.75H12.5V11.25H13.75ZM14.8706 8.62063L12.6831 10.8081L13.5669 11.6919L15.7544 9.50437L14.8706 8.62063ZM13.5669 10.8081L11.3794 8.62063L10.4956 9.50437L12.6831 11.6919L13.5669 10.8081Z" fill="currentColor" /></svg></div>
                        Ajouter une image
                    </button>
                    <input type="file" id="upload-file-image" style={{ "display": "none" }} onChange={fileActionUpload} accept="image/*" />
                </label>
                {isLoader && <div className="loader"></div>}
            </div>
            {listImgUser.length > 0 && whichSubSectionOpen === 'main' &&
                <div>
                    <div className="tout-afficher-shape-section">
                        <div><h3> Mes images </h3></div>
                        <div><h3 onClick={() => setWhichSubSectionOpen('mesimages')} style={{ cursor: 'pointer' }}> Tout Afficher </h3></div>
                    </div>
                    <div className="list-image-section">{listImgUser}</div>
                </div>
            }
            {whichSubSectionOpen === 'mesimages' && <div>
                <div className="list-image-section-full">
                    {listImgUser}
                </div>
            </div>}

        </div>
    );
}